import React from 'react';

import { Button, Grid } from '@material-ui/core'
import SpecificComponent from './SpecificComponent';
import LocalStorage from '../providers/LocalStorage';


export default class SegmentButtons extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedButtonIndex: this.props.selectedIndexButton || 0
        }
    }

    componentDidMount() {
        this.getTheme()
    }

    css = null

    getTheme = () => {
        //     console.log('get css :');

        //     let ls = new LocalStorage();

        //     let theme = ls.GetUserPreferences().theme

        //     this.css = null



        //     if(theme === 'dark'){
        //         this.css = {
        //             mainColor:'black',
        //             secondColor:'white',
        //             thirdColor:'gray'
        //         }
        //         console.log('this.css :', this.css);

        //     }else if(theme === 'light'){
        this.css = {
            mainColor: 'white',
            secondColor: this.props.color ? this.props.color : '#363636',
            thirdColor: '#d0d0d0'
        }
        //         console.log('this.css :', this.css);
        //     }
    }



    generateButton = (clickEvent, text, idx) => {

        this.getTheme()
        let applyedStyle = { flexDirection: 'column', whiteSpace: 'nowrap', width: 'fit-content', display: 'flex' }

        // daca este buton selectat (active)
        if (this.state.selectedButtonIndex === idx) {

            // applyedStyle['backgroundColor'] = this.theme.secondColor
            // applyedStyle['color'] = this.theme.mainColor 
            applyedStyle['backgroundColor'] = this.css.mainColor
            applyedStyle['color'] = this.css.secondColor
        }
        else {
            // applyedStyle['backgroundColor'] = this.theme.mainColor
            // applyedStyle['color'] = this.theme.secondColor
            applyedStyle['backgroundColor'] = this.css.mainColor
            applyedStyle['color'] = this.css.thirdColor
        }



        // by default aplicam middle button
        //applyedStyle['borderTopColor'] = this.theme.mainColor
        //applyedStyle['borderTopWidth'] = '1px'

        // applyedStyle['borderButtomColor'] = this.theme.mainColor
        applyedStyle['borderButtomColor'] = this.css.thirdColor
        applyedStyle['borderLeft'] = 'none'
        applyedStyle['borderRight'] = 'none'

        applyedStyle['borderBottomLeftRadius'] = 0
        applyedStyle['borderTopLeftRadius'] = 0
        applyedStyle['borderBottomRightRadius'] = 0
        applyedStyle['borderTopRightRadius'] = 0

        //daca este primul suprascriem
        if (idx === 0) {
            //  applyedStyle['borderLeft'] = `1px solid ${this.theme.secondColor}`
            applyedStyle['borderLeft'] = `1px solid ${this.css.thirdColor}`
            applyedStyle['borderRight'] = 'none'

            applyedStyle['borderBottomRightRadius'] = 0
            applyedStyle['borderTopRightRadius'] = 0

            applyedStyle['borderBottomLeftRadius'] = '4px'
            applyedStyle['borderTopLeftRadius'] = '4px'
        } else if (idx > 0 && idx < this.props.buttons.length - 1) {
            applyedStyle['borderLeft'] = `1px solid ${this.css.thirdColor}`


            applyedStyle['borderBottomRightRadius'] = 0
            applyedStyle['borderTopRightRadius'] = 0

            //applyedStyle['borderBottomLeftRadius'] = '4px'
            // applyedStyle['borderTopLeftRadius'] = '4px'
        }
        // la fel, daca cumva este ultimul , suprascriem
        else if (idx === this.props.buttons.length - 1) {
            // applyedStyle['borderRight'] = `1px solid ${this.theme.secondColor}`
            applyedStyle['borderRight'] = `1px solid ${this.css.thirdColor}`
            applyedStyle['borderLeft'] = `1px solid ${this.css.thirdColor}`

            // applyedStyle['borderLeft'] = 'none'
            applyedStyle['borderBottomLeftRadius'] = 0
            applyedStyle['borderTopLeftRadius'] = 0

            applyedStyle['borderBottomRightRadius'] = '4px'
            applyedStyle['borderTopRightRadius'] = '4px'
        }


        return <Button style={{}} variant="outlined" key={idx} style={applyedStyle} onClick={() => this.oneButtonClick(idx, clickEvent)} > {text} </Button>

    }

    oneButtonClick = (idx, propsCallBack) => {
        this.setState({
            selectedButtonIndex: idx
        })
        propsCallBack(idx)
    }

    render() {
        return (
            <div>
                {this.props.myStyle ?
                    <div className='pm-segment-container' style={{
                        width: this.props.myStyle.width,
                        margin: this.props.myStyle.margin,
                        marginRight: this.props.myStyle.marginRight,
                        display: this.props.myStyle.display
                    }}  >

                        <div style={{
                            textAlign: 'center',
                            marginTop: '2px',
                            maxWidth: 'none',
                            left: 0,
                            right: 0,
                            margin: 'auto',
                            display: 'flex',
                            width: 'fit-content'

                        }} >

                            {
                                this.props.buttons.map((b, idx) => {
                                    return (
                                        this.generateButton(b.onSegButClick, b.text, idx)
                                    )
                                })
                            }

                        </div>

                    </div>
                    :
                    <div>
                         <div style={{
                            textAlign: 'center',
                            marginTop: '2px',
                            maxWidth: 'none',
                            left: 0,
                            right: 0,
                            margin: 'auto',
                            display: 'flex',
                            width: 'fit-content'

                        }} >

                            {
                                this.props.buttons.map((b, idx) => {
                                    return (
                                        this.generateButton(b.onSegButClick, b.text, idx)
                                    )
                                })
                            }

                        </div>
                        
                    </div>
                
            }
            </div>



        );
    }
}
